import React from 'react'
import TextInput from '../../inputs/text'

type Props = {
    className: string
    value: string
    onChange: Function
}

const SourceCaption = ({ className = '', value, onChange }: Props) => (
    <div className={className}>
        <TextInput
            type="text"
            value={value}
            placeholder="Add a source caption"
            buttonLabel="Save"
            onSubmit={onChange}
        />
    </div>
)

export default SourceCaption
